import { SENS_VENTE } from '@/configuration/devisConf';
import moment from 'moment';

export default function genererCritereRechercheBafCommande() {
  return {
    auto: null,
    agencesId: [],
    fournisseursId: [],
    annonceursId: [],
    payeursId: [],
    dates: {
      dateDebut: (moment().startOf('year')).toDate(),
      dateFin: (moment().endOf('year')).toDate(),
    },
    datesBaf: {
      dateDebut: null,
      dateFin: null,
    },
    assistantIds: [],
    bonAFacturer: null,
    aFacturer: null,
    quiABaf: null,
    lignesCommandeLibelle: null,
    lignesCommandeRegroupementLibelle: null,
    societeId: null,
    sens: SENS_VENTE,
    groupeIds: [],
    enseigneIds: [],
    facturationFaite: null,
    themes: [],
  };
}
